import { MallApi } from "@/api/MallApi";
import { TagsServiceModel } from "../globalService";
import { AddressModel } from "@/global";
const mallApi = new MallApi();

const globalUrl = {
  gw: {
    getConfig: '/gw/app/mallUnion/getConfig',
    findMallNaviConfig: '/gw/app/mallUnion/unionMallConfig/findMallNaviConfig',
    getTags: '/gw/app/trade/promotion/tags',
  }
}

/**
 * 获取百福得全局配置
 * @returns Promise
 */
export const loadConfig = () => {
  return mallApi.Post<any>(globalUrl['gw'].getConfig, null, { cacheData: true })
}

/**
 * 获取百福得菜单
 * @param baseChannelNo channel
 * @returns 
 */
export const loadMenus = (baseChannelNo: string) => {
  return mallApi.Post<any>(globalUrl['gw'].findMallNaviConfig, { baseChannelNo }, { cacheData: true })
}

/**
 * 获取营销属性
 * @param baseChannelNo channel
 * @returns 
 */
export const getTags = (goodsList: TagsServiceModel[], address?: AddressModel) => {
  return mallApi.Post<any>(globalUrl['gw'].getTags, { goodsList, ...address })
}